import {Box, Grid} from "@mui/material";
import {CustomItemDetialAvatar} from "./CustomItemDetialAvatar";
import {theme} from "../../themes/theme";

interface IItemDetail{
    price:string
    name:string
    quantity:string
    iconAvatar: React.ReactNode;
}
export const CustomItemDetailShoppingCart = ({name, price, quantity,iconAvatar}:IItemDetail) => {
    return (
        <Box sx={{display: "flex"}}>

            <Box>
                <CustomItemDetialAvatar iconAvatar={iconAvatar}/>
            </Box>
            <Box sx={{marginLeft: "0.5rem", display: "flex", justifyContent: "center", alignItems: "center"}}>
                <Box sx={{fontWeight:theme.typography.fontWeightLight}}>
                    <Box>
                        {name}
                    </Box>
                    <Box>
                        Cantidad: {quantity}
                    </Box>

                    <Box>
                        Precio: GTQ {price}
                    </Box>
                </Box>
            </Box>

        </Box>
    );
};